import { FunctionComponent, useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { SelectGroupStyled } from './styled';
import Select from 'react-select';
import { emptyString } from '~/constants/string';

export interface SelectGroupProps {
  label?: string;
  value?: any;
  options: any[];
  onChange?: Function;
  disabled?: boolean;
  placeholder?: string;
  customSelectOption?: (props: any) => JSX.Element;
  noOptionsMessage?: ((obj: { inputValue: string }) => string | null) | undefined;
}

const SelectGroup: FunctionComponent<SelectGroupProps> = ({
  value,
  options = [],
  label = emptyString,
  onChange,
  disabled = false,
  placeholder = emptyString,
  customSelectOption,
  noOptionsMessage = undefined,
}) => {
  const [selectValue, setSelectValue] = useState(value);

  useEffect(() => {
    setSelectValue(value);
  }, [value]);

  const onChangeValue = (value: any) => {
    if (!onChange) {
      return;
    }

    setSelectValue(value);

    onChange(value);
  };

  const selectOption = (props: any) => {
    if (customSelectOption) {
      return <div className="customSelectOption">{customSelectOption(props)}</div>;
    }
  };

  const selectedOption = selectValue
    ? typeof selectValue === 'object' && selectValue.value !== undefined
      ? selectValue
      : options.find((option) => option.value === selectValue) || null
    : null;

  return (
    <SelectGroupStyled>
      {label && <Form.Label> {label} </Form.Label>}
      <Select
        options={options}
        value={selectedOption}
        onChange={(event) => onChangeValue(event)}
        isDisabled={disabled}
        placeholder={placeholder}
        className="customSelect"
        classNamePrefix="SelectGroup"
        formatOptionLabel={customSelectOption ? (option) => selectOption(option) : undefined}
        noOptionsMessage={noOptionsMessage}
      />
    </SelectGroupStyled>
  );
};

export default SelectGroup;
